import React, { useEffect, useState } from 'react';

const LiveChat = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    { type: 'bot', text: 'Hi! 👋 How can we help you today?' }
  ]);
  const [messageInput, setMessageInput] = useState('');

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  const handleSendMessage = () => {
    if (messageInput.trim()) {
      // Add user message
      setMessages([...messages, { type: 'user', text: messageInput }]);
      setMessageInput('');
      
      // Simulate bot response after a delay
      setTimeout(() => {
        setMessages(prev => [...prev, { type: 'bot', text: 'Thanks for your message! Our team will respond shortly. ✨' }]);
      }, 1000);
    }
  };

  return (
    <div className="chat-widget-container">
      <button className="chat-toggle-btn" onClick={toggleChat} title="Open chat">
        💬
      </button>
      
      <div className={`chat-window ${isChatOpen ? 'open' : ''}`}>
        <div className="chat-header">
          <h3>Zentak Support</h3>
          <button onClick={() => setIsChatOpen(false)} title="Close chat">✕</button>
        </div>
        
        <div className="chat-messages">
          {messages.map((msg, index) => (
            <div key={index} className={`chat-message ${msg.type}-message`}>
              <p>{msg.text}</p>
            </div>
          ))}
        </div>
        
        <div className="chat-input-area">
          <input 
            type="text" 
            placeholder="Type your message..." 
            className="chat-input"
            value={messageInput}
            onChange={(e) => setMessageInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
          />
          <button className="chat-send-btn" onClick={handleSendMessage}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiveChat;
